export default __webpack_public_path__ + "static/media/img7.c20855d5.png";